var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8083 4H1.81724C0.924106 4 0.193359 3.28 0.193359 2.4V1.6C0.193359 0.72 0.924106 0 1.81724 0H14.8083C15.7014 0 16.4322 0.72 16.4322 1.6V2.4C16.4322 3.28 15.7014 4 14.8083 4ZM14.8083 6H1.81724C0.924106 6 0.193359 6.72 0.193359 7.6V8.4C0.193359 9.28 0.924106 10 1.81724 10H14.8083C15.7014 10 16.4322 9.28 16.4322 8.4V7.6C16.4322 6.72 15.7014 6 14.8083 6ZM14.8083 12H1.81724C0.924106 12 0.193359 12.72 0.193359 13.6V14.4C0.193359 15.28 0.924106 16 1.81724 16H14.8083C15.7014 16 16.4322 15.28 16.4322 14.4V13.6C16.4322 12.72 15.7014 12 14.8083 12Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableViewIcon);
export default __webpack_public_path__ + "static/media/tableViewIcon.8cc312407d5b15c44d4c37bc62779c25.svg";
export { ForwardRef as ReactComponent };